module.exports = "/assets/4248b36778b7c3bd1d22654be50dee24.jpg";